import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '首页',
      component: () => import('@/views/layout/index.vue'),
      redirect: '/home',
      children: [
        {
          path: '/home',
          name: '首页',
          component: () => import('@/views/home/index.vue'),
          meta: {
            hideBreadCrumb: true
          },
        },
        {
          path: '/search',
          name: '搜索',
          component: () => import('@/views/search/index.vue'),
          meta: {
            hideBreadCrumb: true,
            bgColor: true
          },
        },
        {
          path: '/articleDetail',
          name: '文章详情',
          component: () => import('@/views/article/Detail.vue'),
          meta: {
            bgColor: true
          },
        },
        {
          path: '/expertDetail',
          name: '专家详情',
          component: () => import('@/views/expert/Detail.vue'),
          meta: {
            bgColor: true
          },
        },
        {
          path: '/benchmarkDetail',
          name: '标杆项目详情',
          component: () => import('@/views/benchmark/Detail.vue'),
          meta: {
            bgColor: true
          },
        },
        {
          path: '/benchmark',
          name: '标杆项目',
          component: () => import('@/views/benchmark/index.vue'),
        },
        {
          path: '/committee',
          name: '委员会列表',
          component: () => import('@/views/committee/index.vue'),
        },
        {
          path: '/committeeDetail',
          name: '委员会详情',
          component: () => import('@/views/committee/Detail.vue'),
          meta: {
            bgColor: true
          },
        },
        {
          path: '/newDetail',
          name: '新闻动态详情',
          component: () => import('@/views/new/Detail.vue'),
          meta: {
            bgColor: true
          },
        },
        {
          path: '/health',
          name: '健康中国基层慢病项目',
          component: () => import('@/views/health/index.vue'),
        },
        {
          path: '/healthDetail',
          name: '健康中国基层慢病项目详情',
          component: () => import('@/views/health/Detail.vue'),
          meta: {
            bgColor: true
          },
        },
        {
          path: '/new',
          name: '新闻动态',
          component: () => import('@/views/new/index.vue'),
        },
        {
          path: '/policyDetail',
          name: '政策法规详情',
          component: () => import('@/views/policy/Detail.vue'),
          meta: {
            bgColor: true
          },
        },
        {
          path: '/policy',
          name: '政策法规',
          component: () => import('@/views/policy/index.vue'),
        },
        {
          path: '/infoDetail',
          name: '信息公开详情',
          component: () => import('@/views/info/Detail.vue'),
          meta: {
            bgColor: true
          },
        },
        {
          path: '/info',
          name: '信息公开',
          component: () => import('@/views/info/index.vue'),
        },
        {
          path: '/contact',
          name: '联系我们',
          component: () => import('@/views/contact/index.vue'),
        },
        {
          path: '/about',
          name: '关于我们',
          component: () => import('@/views/about/index.vue'),
          redirect: '/about/introduce',
          children: [
            {
              path: '/about/introduce',
              name: '中心介绍',
              component: () => import('@/views/about/child/Introduce.vue'),
              meta: {
                about: true
              },
            },
            // {
            //   path: '/about/contact',
            //   name: '联系我们',
            //   component: () => import('@/views/about/child/Contact.vue'),
            //   meta: {
            //     bgColor: true
            
            //   },
            // },
            {
              path: '/about/constitution',
              name: '章程',
              component: () => import('@/views/about/child/Constitution.vue'),
              meta: {
                about: true
              },
            },
            {
              path: '/about/organization',
              name: '组织架构',
              component: () => import('@/views/about/child/Organization.vue'),
              meta: {
                about: true
              },
            },
            {
              path: '/about/council',
              name: '理事会',
              component: () => import('@/views/about/child/Council.vue'),
              meta: {
                about: true
              },
            },
            {
              path: '/about/certificate',
              name: '证书资质',
              component: () => import('@/views/about/child/Certificate.vue'),
              meta: {
                about: true
              },
            },
          ]
        }
      ]
    },
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js